const isFunction = test => typeof test === 'function'

export default isFunction
